import type { TransactionDetails } from 'apis/TransactionApi';
import { LicenseType, TransactionType } from 'types';

export const DEFAULT_TRANSACTION_FORM: TransactionDetails = {
    AllowReview: true,
    AllowStudyGuide: true,
    Codes: '',
    CourseGateType: {
        Description: '',
        Id: -1,
        label: '',
        Name: '',
        NameAndDescription: '',
        title: '',
        TranslatedName: '',
        value: -1
    },
    CreatedBy: '',
    CreatedDate: new Date(),
    CreatedDateString: '',
    ExpirationDate: null,
    ExpirationDateString: null,
    Groups: '',
    Id: 0,
    Identifier: '',
    IndividualMaxStudents: 0,
    Instructor: '',
    IsDuplicated: false,
    IsUnlimited: false,
    LeastOrderExpiratiDate: undefined,
    LeastOrderExpirationDate: new Date(),
    LeastOrderExpirationDateString: '',
    LicenseName: '',
    LicenseType: LicenseType.Site,
    Name: '',
    Notes: '',
    NumOfBooks: 0,
    NumOfCourses: 0,
    NumOfStudents: 0,
    NumOfTests: 1000,
    NumXEDAccess: 0,
    OrderIds: [],
    PendingBooks: [],
    PendingCourses: [],
    PendingTests: [],
    RestrictingOrder: 0,
    StartDate: new Date(),
    StartDateString: '',
    TestingMode: true,
    TestsRemaining: 100,
    TrainingMode: true,
    TransactionType: TransactionType.Assignment,
    UserId: '',
    UsesRemaining: 0,
    XEDExternalId: ''
};